const ContactUs = () => {
    return (
        <div className='w-full h-screen flex items-center justify-center'>
            <h1 className='font-interMedium text-2xl text-[#101828]'>Contact Us</h1>
        </div>
    );
};

export default ContactUs;
